if (!customElements.get('ac-delivery-timeline')) {
  customElements.define('ac-delivery-timeline', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.configured !== 'true') return;
      const { processing, min, max, business, zone } = this.dataset;
      const days = [processing, min, max].map(Number);
      if (days.some(n => !Number.isInteger(n) || n < 0 || n > 60) || days[2] < days[1]) return;
      try {
        const parts = new Intl.DateTimeFormat('en-US', { timeZone: zone || 'UTC', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
        const part = type => Number(parts.find(p => p.type === type).value);
        const today = new Date(Date.UTC(part('year'), part('month') - 1, part('day'), 12));
        const add = (start, count) => {
          const d = new Date(start);
          while (count > 0) { d.setUTCDate(d.getUTCDate() + 1); if (business !== 'true' || ![0, 6].includes(d.getUTCDay())) count--; }
          return d;
        };
        const completed = add(today, days[0]);
        const first = add(completed, days[1]), last = add(completed, days[2]);
        const makeTime = d => { const el = document.createElement('time'); el.dateTime = d.toISOString().slice(0, 10); el.textContent = new Intl.DateTimeFormat('en-US', { month: 'long', day: '2-digit', timeZone: 'UTC' }).format(d); return el; };
        this.querySelector('[data-date="completed"]').replaceChildren(makeTime(completed));
        this.querySelector('[data-date="delivered"]').replaceChildren(makeTime(first), ...(days[1] === days[2] ? [] : [document.createTextNode('–'), makeTime(last)]));
        this.querySelector('[data-delivery-note]').textContent = 'Estimated dates. ' + (business === 'true' ? 'Weekends excluded; holidays may affect delivery.' : 'Actual delivery may vary by destination.');
      } catch (_) { /* Invalid time zones retain the unconfirmed state. */ }
    }
  });
}
